import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 30, className = "", as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easing }}
    >
      {children}
    </MotionTag>
  );
}

// Masked line-by-line reveal for hero headings
export function MaskedLines({ lines, className = "", lineClassName = "", startDelay = 0.2 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: startDelay + i * 0.14, ease: easing }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
